import { render, staticRenderFns } from "./WenzhenDetail.vue?vue&type=template&id=3da2b04d&scoped=true"
import script from "./WenzhenDetail.vue?vue&type=script&lang=js"
export * from "./WenzhenDetail.vue?vue&type=script&lang=js"
import style0 from "./WenzhenDetail.vue?vue&type=style&index=0&id=3da2b04d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da2b04d",
  null
  
)

export default component.exports